import { Immutable } from "immer";
import React from "react";
import { t } from "ttag";

import { getDocument } from "@thelabnyc/thelabui/src/utils/dom";

import { Category } from "../../models/tempur-love-grid";
import { TempurLoveRootUrlContext } from "../../utils/tempurLoveGridContext";

type Props = Immutable<{
    categories?: (Category & { override_url?: string })[];
    city?: string;
    state?: string;
}>;

export const CategoriesFooter = ({
    categories,
    city,
    state,
}: Props): React.JSX.Element => {
    const contextRootUrl = React.useContext(TempurLoveRootUrlContext);
    const [domRootUrl, setDomRootUrl] = React.useState<string | undefined>(
        undefined,
    );

    React.useEffect(() => {
        // Skip DOM query if context provides the URL (SSR path)
        if (contextRootUrl) return;

        const document = getDocument();
        const heroElem =
            document?.querySelector<HTMLElement>(".tempurlove-hero");
        setDomRootUrl(heroElem?.dataset.tempurLoveRootUrl);
    }, [contextRootUrl]);

    const rootURL = contextRootUrl ?? domRootUrl;
    return (
        <footer className="social-icons">
            <div className="social-icons__tags">
                {categories?.map((category) => (
                    <React.Fragment key={category.slug}>
                        <span className="ada-screenreader-only">
                            {t`Filter Stories by category`}
                        </span>
                        <a
                            href={
                                category.override_url ||
                                (rootURL || "") +
                                    "c/" +
                                    encodeURIComponent(category.slug) +
                                    "/"
                            }
                            title={category.name}
                        >
                            <img
                                src={category.image}
                                alt={category.name}
                                loading="lazy"
                                decoding="async"
                            />
                            <span>{category.name}</span>
                        </a>
                    </React.Fragment>
                ))}
                {city && state && (
                    <span>
                        {city}, {state}
                    </span>
                )}
            </div>
        </footer>
    );
};
